import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	content: {
		id: 'software-onboarding-nudges--next.navigation-apps.content',
		defaultMessage: 'Search for the tools you currently use, or discover something new.',
		description:
			'Nudge content that will show up to new users when users click on capture integrations checklist item in quickstart. This Nudge guides the user to learn more about marketplace apps.',
	},
});
